// extracted by css-extract-rspack-plugin
var _1 = "_67ztCRQpn4DiOrHeOYyBoA--";
var _2 = "lN0MrtQrXpybonc0pN1Lfg--";
export { _1 as "centerer", _2 as "wrapper" }
